import React from 'react';
import { Link } from 'react-router-dom';
import { Scale, FileX, HandHeart, Building2, DollarSign, ArrowLeft } from 'lucide-react';

const ServicesSection = () => {
  const services = [
    {
      id: 'bankruptcy',
      title: 'חדלות פירעון',
      path: '/insolvency-lawyer',
      icon: FileX,
      description:
        'כשחובות נערמים והלחץ לא נותן מנוח, קל להרגיש שהקרקע נשמטת מתחת לרגליים. כאן נכנס הליך חדלות פירעון - מסגרת משפטית שנועדה להעניק לך הגנה, עצירה של הליכי גבייה והזדמנות אמיתית לבנות עתיד כלכלי חדש',
      features: [
        'פתיחת ההליך בצורה נכונה ומהירה',
        'טיפול בהסרת עיקולים ועיכוב הליכים מהיר',
        'יצירת תוכנית מותאמת אישית שתוביל אותך לשיקום ולחופש כלכלי',
        'ייצוג וליווי משפטי עד ליציאה לדרך כלכלית חדשה',
      ],
    },
    {
      id: 'enforcement',
      title: 'הוצאה לפועל',
      path: '/execution-lawyer',
      icon: Scale,
      description:
        'עבור חייבים רבים, מדובר במערכת סבוכה ומרתיעה, הכוללת הליכים מהירים וקשים כגון עיקולי חשבונות, תפיסת רכבים, עיקול משכורות והטלת מגבלות שונות. במצבים אלו נדרש מענה משפטי מדויק ומקצועי.',
      features: [
        'עיכוב וביטול הליכים - ביטול עיקולים על חשבון הבנק, המשכורת ועוד',
        'פריסת חובות והסדרת תוכנית החזרים',
        'קבלת צווי תשלומים בהתאם ליכולת ההחזר',
        'איחוד תיקים תחת תיק אחד',
        'הגשת התנגדויות במקרים המתאימים',
        'טיפול בחובות מזונות עבר',
      ],
    },
    {
      id: 'debt-arrangement',
      title: 'הסדר חובות',
      path: '/debt-settlement-lawyer',
      icon: HandHeart,
      description:
        'הסדר חובות מהווה כלי משפטי מוסדר שנועד לאפשר לחייב להגיע להבנות עם נושיו, תוך פריסה או הפחתה של החוב, והכול במסגרת מסודרת המעניקה ודאות הן לחייב והן לנושה.',
      features: [
        'ניהול מו״מ עם נושים',
        'פריסת חובות בהתאמה ליכולת הכלכלית',
        'הפחתת חוב במקרים המתאימים',
        'ביטול או הקפאת הליכים',
        'גיבוש תכנית החזר כוללת',
        'הסדרה מיוחדת של חובות מזונות או חובות מס',
      ],
    },
    {
      id: 'company-liquidation',
      title: 'פירוק חברות',
      path: '/company-liquidation',
      icon: Building2,
      description:
        'חברה שאינה מצליחה לעמוד בהתחייבויותיה נדרשת לעיתים לסיים את דרכה במסגרת הליך פירוק. מטרת הפירוק היא להביא לסגירת החברה באופן מסודר, להסדיר את יחסיה עם נושיה ולחלק את נכסיה.',
      features: [
        'ייעוץ מקדים ובחינת החלופות',
        'פירוק מרצון על ידי בעלי המניות',
        'פירוק על ידי בית המשפט',
        'מינוי מפרק וניהול הקשר עמו',
        'הסדרת חובות החברה',
        'חלוקת נכסים לבעלי המניות',
      ],
    },
    {
      id: 'financial-claims',
      title: 'תביעות כספיות',
      path: '/monetary-claims-lawyer',
      icon: DollarSign,
      description:
        'מערכת המשפט מעניקה לכל אדם או עסק אפשרות לדרוש את כספו בחזרה כאשר התחייבות כלכלית לא קוימה. תביעה כספית יכולה לנבוע ממגוון סיטואציות - חוב שלא שולם, הלוואה שלא הוחזרה או נזק שנגרם.',
      features: [
        'ניסוח והגשת כתב תביעה ברור ומבוסס ראיות',
        'הגשת כתב הגנה וניהול אסטרטגי של ההליך',
        'איסוף מסמכים, עדויות וחוות דעת מקצועיות',
        'ניהול מו״מ והגעה להסכמות מחוץ לבית המשפט',
        'ליווי מלא עד שלב פסק הדין',
      ],
    },
  ];

  const ServiceCard = ({ service }) => (
    <div className="h-full">
      <div className="h-full bg-gradient-to-br from-gray-900 via-gray-800 to-black rounded-2xl p-6 shadow-2xl border border-amber-400/20 hover:border-amber-400/40 transition-all duration-300 hover:shadow-amber-500/10 hover:shadow-2xl flex flex-col">
        <div className="w-14 h-14 bg-gradient-to-br from-amber-500 to-yellow-500 rounded-xl flex items-center justify-center mb-4 mx-auto">
          <service.icon className="w-7 h-7 text-white" />
        </div>

        <h3 className="text-xl font-bold mb-4 bg-gradient-to-r from-amber-300 via-yellow-400 to-amber-300 bg-clip-text text-transparent text-center">
          {service.title}
        </h3>

        <div className="space-y-2 flex-grow">
          {service.features.map((feature, featureIndex) => (
            <div key={featureIndex} className="flex items-start gap-2">
              <div className="w-1.5 h-1.5 bg-gradient-to-r from-amber-400 to-yellow-400 rounded-full mt-2 flex-shrink-0" />
              <span className="text-gray-400 text-sm font-bold leading-relaxed">{feature}</span>
            </div>
          ))}
        </div>

        <Link
          to={service.path}
          className="mt-6 flex items-center justify-center gap-2 w-full py-3 rounded-lg bg-gradient-to-r from-amber-600 to-yellow-600 text-white font-bold text-sm hover:from-amber-500 hover:to-yellow-500 transition-all duration-300 group"
        >
          <span>קרא עוד</span>
          <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
        </Link>
      </div>
    </div>
  );

  return (
    <div className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800">השירותים שלנו</h2>
        </div>

        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:max-w-5xl md:mx-auto">
            {services.slice(0, 3).map((service) => (
              <ServiceCard key={service.id} service={service} />
            ))}
          </div>
          <div className="md:col-span-3 lg:col-span-3">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:max-w-2xl md:mx-auto">
              {services.slice(3).map((service) => (
                <ServiceCard key={service.id} service={service} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesSection;
